import { createRoot } from 'react-dom/client';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'react-toastify/dist/ReactToastify.css';
import AudioRecorder from 'audio-recorder-polyfill';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import App from './App';

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        // the translations
        // (tip move them in a JSON file and import them,
        // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
        resources: {
            en: {
                translation: {
                    SKIP: 'Skip',
                    UNDO: 'Undo',
                    SEND: 'Send',
                    RECORD: 'Record',
                    PLACEHOLDER: 'Enter your message here',
                    LOADING: 'Loading...',
                    'Very satified': 'Very satisfied',
                    'Very dissatisfied': 'Very dissatisfied',
                    'Very correct/fair': 'Very correct/fair',
                    'Not fair at all': 'Not fair at all',
                    'Extremely likely': 'Extremely likely',
                    'Not at all likely': 'Not at all likely',
                    Expired: 'Sorry, the survey invite has expired.'
                }
            },
            es: {
                translation: {
                    SKIP: 'Omitir',
                    UNDO: 'Volver atrás',
                    SEND: 'Enviar',
                    RECORD: 'Grabar mensaje',
                    PLACEHOLDER: 'Introduzca su mensaje aquí',
                    LOADING: 'Cargando...',
                    'Very satified': 'Muy satisfecho',
                    'Very dissatisfied': 'Muy poco satisfecho',
                    'Very correct/fair': 'Muy correcta/justa',
                    'Not fair at all': 'Nada justa',
                    'Extremely likely': 'Muy probable',
                    'Not at all likely': 'Nada probable'
                }
            },
            el: {
                translation: {
                    SKIP: 'Paralripo',
                    SEND: 'Steilete',
                    RECORD: 'Rekór',
                    UNDO: 'Xekano',
                    PLACEHOLDER: 'Eisagágete to mínymá sas edó',
                    LOADING: 'Fórtosi...'
                }
            },
            is: {
                translation: {
                    SKIP: 'Skippa',
                    SEND: 'Senda',
                    RECORD: 'Met',
                    UNDO: 'Aftaka',
                    PLACEHOLDER: 'Sláðu inn skilaboðin þín hér',
                    LOADING: 'Cargando...'
                }
            },
            fi: {
                translation: {
                    SKIP: 'Ohita',
                    UNDO: 'Kumoa',
                    SEND: 'Lähettää',
                    RECORD: 'Nauhoita viesti',
                    PLACEHOLDER: 'Kirjoita viestisi tähän',
                    LOADING: 'Ladataan...',
                    'Very satified': 'Erittäin tyytyväinen',
                    'Very dissatisfied': 'Erittäin tyytymätön',
                    'Very correct/fair': 'Kyllä',
                    'Not fair at all': 'Ei',
                    'Extremely likely': 'Erittäin todennäköisesti',
                    'Not at all likely': 'Ei lainkaan todennäköistä',
                    Expired: 'Istuntosi on vanhentunut'
                }
            },
            dk: {
                translation: {
                    SKIP: 'Spring over',
                    UNDO: 'Fortryd',
                    SEND: 'Send',
                    RECORD: 'Optag din besked',
                    PLACEHOLDER: 'Indtast din besked her',
                    LOADING: 'Indlæser...',
                    'Very satified': 'Meget tilfreds',
                    'Very dissatisfied': 'Meget utilfreds',
                    'Very correct/fair': 'Ja',
                    'Not fair at all': 'Nej',
                    'Extremely likely': 'Helt sikkert',
                    'Not at all likely': 'Helt sikkert ikke'
                }
            },
            'it-CH': {
                translation: {
                    SKIP: 'Saltare',
                    UNDO: 'Annullare',
                    SEND: 'Inviare',
                    RECORD: 'Registrare',
                    PLACEHOLDER: 'Inserisci il tuo messaggio qui',
                    LOADING: 'Caricamento...',
                    'Very satified': 'molto soddisfatto',
                    'Very dissatisfied': 'per niente soddisfatto',
                    'Very correct/fair': 'molto corretto',
                    'Not fair at all': 'per niente corretto',
                    'Extremely likely': 'molto probabilmente',
                    'Not at all likely': 'per niente probabile',
                    Expired: 'La sua sessione è scaduta.'
                }
            },
            it: {
                translation: {
                    SKIP: 'Saltare',
                    UNDO: 'Annullare',
                    SEND: 'Inviare',
                    RECORD: 'Registrare',
                    PLACEHOLDER: 'Inserisci il tuo messaggio qui',
                    LOADING: 'Caricamento...',
                    'Very satified': 'molto soddisfatto',
                    'Very dissatisfied': 'per niente soddisfatto',
                    'Very correct/fair': 'molto corretto',
                    'Not fair at all': 'per niente corretto',
                    'Extremely likely': 'molto probabilmente',
                    'Not at all likely': 'per niente probabile'
                }
            },
            sk: {
                translation: {
                    SKIP: 'Preskočiť',
                    SEND: 'Odoslať',
                    RECORD: 'záznam',
                    UNDO: 'Späť',
                    PLACEHOLDER: 'Tu zadajte svoju správu',
                    LOADING: 'načítanie...'
                }
            },
            cs: {
                translation: {
                    SKIP: 'Přeskočit ',
                    SEND: 'Odeslat',
                    RECORD: 'záznam',
                    UNDO: 'Zrušit',
                    PLACEHOLDER: 'Zde zadejte svou zprávu',
                    LOADING: 'načítanie...'
                }
            },
            sv: {
                translation: {
                    SKIP: 'Hoppa',
                    UNDO: 'Ångra',
                    SEND: 'Skicka',
                    RECORD: 'Spela in meddelande',
                    PLACEHOLDER: 'Ange ditt meddelande här',
                    LOADING: 'Läser in...',
                    'Very satified': 'Väldigt nöjd',
                    'Very dissatisfied': 'Väldigt missnöjd',
                    'Very correct/fair': 'Väldigt rimlig',
                    'Not fair at all': 'Orimlig',
                    'Extremely likely': 'Extremt troligt',
                    'Not at all likely': 'Inte alls troligt',
                    Expired: 'Din session har löpt ut'
                }
            },
            hu: {
                translation: {
                    SKIP: 'Felvétel',
                    SEND: 'Küldés',
                    RECORD: 'kihagyása',
                    UNDO: 'Betöltés',
                    PLACEHOLDER: 'Írja be üzenetét ide',
                    LOADING: 'visszavonása...'
                }
            },
            ro: {
                translation: {
                    SKIP: 'Ocolire',
                    SEND: 'Trimite',
                    RECORD: 'Înregistrați mesajul',
                    UNDO: 'Anula',
                    PLACEHOLDER: 'Introduceți mesajul dvs. aici',
                    LOADING: 'Se încarcă...',
                    'Very satified': 'Foarte multumit',
                    'Very dissatisfied': 'Foarte nemultumit',
                    'Very correct/fair': 'Extrem de echitabila',
                    'Not fair at all': 'Extrem de neechitabila',
                    'Extremely likely': 'Foarte probabil',
                    'Not at all likely': 'Putin probabil',
                    Expired: 'Sesiunea ta a expirat'
                }
            },
            bg: {
                translation: {
                    SKIP: 'Пропусни',
                    SEND: 'Изпратете',
                    RECORD: 'Запис',
                    UNDO: 'Отмяна',
                    PLACEHOLDER: 'Въведете вашето съобщение тук',
                    LOADING: 'Зареждане...'
                }
            },
            nl: {
                translation: {
                    SKIP: 'Overslaan',
                    SEND: 'Versturen',
                    RECORD: 'Dossier',
                    UNDO: 'ongedaan maken',
                    PLACEHOLDER: 'Vul hier uw bericht in',
                    LOADING: 'Bezig met laden...'
                }
            },
            pl: {
                translation: {
                    SKIP: 'Pomiń',
                    UNDO: 'Cofnij',
                    SEND: 'Wyślij',
                    RECORD: 'Zapisz',
                    PLACEHOLDER: 'Wpisz tutaj swoją wiadomość',
                    LOADING: 'Ładowanie...',
                    'Very satified': 'Bardzo usatysfakcjonowany/a',
                    'Very dissatisfied': 'Nie ustysfakcjonowany/a',
                    'Very correct/fair': 'Bardzo adekwatna',
                    'Not fair at all': 'Nie była adekwatna w ogóle',
                    'Extremely likely': 'Zdecydowanie polecam',
                    'Not at all likely': 'W ogóle nie polecam',
                    Expired: 'Twoja sesja wygasła'
                }
            },
            da: {
                translation: {
                    SKIP: 'Spring over',
                    UNDO: 'Fortryd',
                    SEND: 'Send',
                    RECORD: 'Optag din besked',
                    PLACEHOLDER: 'Indtast din besked her',
                    LOADING: 'Indlæser...',
                    'Very satified': 'Meget tilfreds',
                    'Very dissatisfied': 'Meget utilfreds',
                    'Very correct/fair': 'Ja',
                    'Not fair at all': 'Nej',
                    'Extremely likely': 'Helt sikkert',
                    'Not at all likely': 'Helt sikkert ikke',
                    Expired: ''
                }
            },
            fr: {
                translation: {
                    SKIP: 'Passer',
                    UNDO: 'Annuler',
                    SEND: 'Envoyer',
                    RECORD: 'Enregistrer',
                    PLACEHOLDER: 'Entrez votre message ici',
                    LOADING: 'Chargement...',
                    'Very satified': 'Très satisfait',
                    'Very dissatisfied': 'Pas du tout satisfait',
                    'Very correct/fair': 'Tout à fait adapté',
                    'Not fair at all': 'Pas du tout adapté',
                    'Extremely likely': 'Je recommanderai !',
                    'Not at all likely': 'Je ne recommanderai pas',
                    Expired: 'Ce lien n’est plus valide.'
                }
            },
            'fr-CH': {
                translation: {
                    SKIP: 'Passer',
                    UNDO: 'Annuler',
                    SEND: 'Envoyer',
                    RECORD: 'Enregistrer',
                    PLACEHOLDER: 'Entrez votre message ici',
                    LOADING: 'Chargement...',
                    'Very satified': 'Très satisfait',
                    'Very dissatisfied': 'Très insatisfait',
                    'Very correct/fair': 'Très correct',
                    'Not fair at all': 'Absolument pas correct',
                    'Extremely likely': 'Je recommanderai !',
                    'Not at all likely': 'Je ne recommanderai pas',
                    Expired: 'Votre session a expiré.'
                }
            },
            'de-CH': {
                translation: {
                    SKIP: 'Überspringen',
                    UNDO: 'Abbrechen',
                    SEND: 'Senden',
                    RECORD: 'Speichern',
                    PLACEHOLDER: 'Geben Sie hier Ihre Nachricht ein',
                    LOADING: 'Laden...',
                    'Very satified': 'Sehr zufrieden',
                    'Very dissatisfied': 'Sehr unzufrieden',
                    'Very correct/fair': 'sehr korrekt',
                    'Not fair at all': 'Überhaupt nicht korrekt',
                    'Extremely likely': 'Sehr wahrscheinlich',
                    'Not at all likely': 'Überhaupt nicht wahrscheinlich',
                    Expired: 'Ihre Session ist abgelaufen.'
                }
            },
            de: {
                translation: {
                    SKIP: 'Überspringen',
                    UNDO: 'Abbrechen',
                    SEND: 'Senden',
                    RECORD: 'Speichern',
                    PLACEHOLDER: 'Geben Sie hier Ihre Nachricht ein',
                    LOADING: 'Laden...',
                    'Very satified': 'Sehr zufrieden',
                    'Very dissatisfied': 'Sehr unzufrieden',
                    'Very correct/fair': 'sehr korrekt',
                    'Not fair at all': 'Überhaupt nicht korrekt',
                    'Extremely likely': 'Sehr wahrscheinlich',
                    'Not at all likely': 'Überhaupt nicht wahrscheinlich'
                }
            }
        },
        lng: 'en', // if you're using a language detector, do not define the lng option
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        }
    });
// @ts-ignore
if (!window.MediaRecorder) {
    // @ts-ignore
    window.MediaRecorder = AudioRecorder;
}

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(<App />);
